(function () {
  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function getCollectionBaseUrl() {
    const bodyWrapper = document.querySelector("[data-body-wrapper]");

    let baseUrl = "";

    if (bodyWrapper && bodyWrapper.getAttribute("data-url")) {
      baseUrl = bodyWrapper.getAttribute("data-url");
    } else {
      baseUrl = window.location.pathname;
    }

    baseUrl = baseUrl.split("?")[0].replace(/\/$/, "");

    const parts = baseUrl.split("/").filter(Boolean);

    if (parts[0] === "collections" && parts[1]) {
      return "/collections/" + parts[1];
    }

    return baseUrl;
  }

  document.addEventListener("change", function (event) {
    const select = event.target.closest(".tags-listbox");

    if (!select) return;

    const allTagSelects = document.querySelectorAll(".tags-listbox");
    const selectedTags = [];

    allTagSelects.forEach(function (tagSelect) {
      const value = tagSelect.value;

      if (value) {
        selectedTags.push(value);
      }
    });

    if (selectedTags.length > 0) {
      const query = selectedTags.join("+");

      window.location.href = getCollectionBaseUrl() + "/" + query;
      return;
    }

    window.location.href = getCollectionBaseUrl();
  });

  function debounce(callback, delay) {
    let timer;

    return function () {
      clearTimeout(timer);

      timer = setTimeout(callback, delay);
    };
  }

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function getProductRoot() {
    return (
      document.querySelector(".product-page--root") ||
      document.querySelector("[data-product-page]") ||
      document.querySelector(".product--root") ||
      document
    );
  }

  function getMagnify(root) {
    const value =
      root.getAttribute("data-magnify") ||
      root.dataset.magnify ||
      "2";

    const magnify = parseFloat(value);

    return isNaN(magnify) ? 2 : magnify;
  }

  function isZoomEnabled(root) {
    return root.getAttribute("data-zoom-enabled") !== "false";
  }

  function getActiveImageId(root) {
    const activeImage =
      root.querySelector('.product-page--image[data-active="true"]') ||
      root.querySelector(".product-page--image");

    if (!activeImage) return null;

    return activeImage.getAttribute("data-id");
  }

  function hideAllZoomImages(root) {
    root.querySelectorAll(".product-page--zoom-image").forEach(function (zoomImage) {
      zoomImage.style.display = "none";
    });
  }

  function setupProductZoom() {
    const root = getProductRoot();
    const imageContainer = root.querySelector(".product-page--images-container");
    const mainImages = root.querySelectorAll(".product-page--image");
    const zoomImages = root.querySelectorAll(".product-page--zoom-image");

    if (!imageContainer || !mainImages.length || !zoomImages.length) return;
    if (!isZoomEnabled(root)) return;

    const magnify = getMagnify(root);

    hideAllZoomImages(root);

    if (imageContainer.dataset.zoomReady === "true") return;

    imageContainer.dataset.zoomReady = "true";

    imageContainer.addEventListener("mouseenter", function () {
      if (isMobile()) return;

      const activeImageId = getActiveImageId(root);
      const activeZoomImage = root.querySelector(
        '.product-page--zoom-image[data-id="' + activeImageId + '"]'
      );

      if (!activeZoomImage) return;

      const imageRoot = activeZoomImage.querySelector(".image--root");

      const wrapperWidth = imageContainer.offsetWidth;
      const wrapperHeight = imageContainer.offsetHeight;

      if (imageRoot) {
        imageRoot.style.width = wrapperWidth * magnify + "px";
      }

      activeZoomImage.style.display = "block";
      activeZoomImage.style.left = "0px";
      activeZoomImage.style.top = "0px";

      imageContainer.dataset.zoomActiveId = activeImageId;
      imageContainer.dataset.zoomWrapperWidth = wrapperWidth;
      imageContainer.dataset.zoomWrapperHeight = wrapperHeight;
    });

    imageContainer.addEventListener("mouseleave", function () {
      hideAllZoomImages(root);
      imageContainer.removeAttribute("data-zoomActiveId");
    });

    imageContainer.addEventListener("mousemove", function (event) {
      if (isMobile()) return;

      const activeImageId = imageContainer.dataset.zoomActiveId || getActiveImageId(root);
      const activeZoomImage = root.querySelector(
        '.product-page--zoom-image[data-id="' + activeImageId + '"]'
      );

      if (!activeZoomImage) return;

      const rect = imageContainer.getBoundingClientRect();

      const wrapperWidth = imageContainer.offsetWidth;
      const wrapperHeight = imageContainer.offsetHeight;

      const relativeLeft = event.clientX - rect.left;
      const relativeTop = event.clientY - rect.top;

      const xRatio = (wrapperWidth * magnify - wrapperWidth) / wrapperWidth;
      const yRatio = (wrapperHeight * magnify - wrapperHeight) / wrapperHeight;

      activeZoomImage.style.left = relativeLeft * -xRatio + "px";
      activeZoomImage.style.top = relativeTop * -yRatio + "px";
    });
  }

  function updateVariantImage(variantId) {
    const root = getProductRoot();

    if (!variantId) return;

    root.querySelectorAll(".product-page--image").forEach(function (image) {
      image.setAttribute("data-active", "false");
    });

    root.querySelectorAll(".product-page--thumb").forEach(function (thumb) {
      thumb.setAttribute("data-active", "false");
    });

    const activeImage = root.querySelector(
      '.product-page--image[data-id="' + variantId + '"]'
    );

    const activeThumb = root.querySelector(
      '.product-page--thumb[data-id="' + variantId + '"]'
    );

    if (activeImage) {
      activeImage.setAttribute("data-active", "true");
    }

    if (activeThumb) {
      activeThumb.setAttribute("data-active", "true");
    }

    hideAllZoomImages(root);
  }

  document.addEventListener("click", function (event) {
    const thumb = event.target.closest(".product-page--thumb");

    if (!thumb) return;

    const variantId = thumb.getAttribute("data-id");

    updateVariantImage(variantId);
  });

  document.addEventListener("keydown", function (event) {
    const thumb = event.target.closest(".product-page--thumb");

    if (!thumb) return;
    if (event.key !== "Enter" && event.key !== " ") return;

    const variantId = thumb.getAttribute("data-id");

    updateVariantImage(variantId);
  });

  document.addEventListener("DOMContentLoaded", function () {
    setupProductZoom();
  });

  document.addEventListener("shopify:section:load", function () {
    setupProductZoom();
  });

  window.addEventListener(
    "resize",
    debounce(function () {
      const root = getProductRoot();

      if (root) {
        hideAllZoomImages(root);
      }
    }, 100)
  );

  function getImageSrc(container) {
    const activeImage =
      container.querySelector('.product-page--image[data-active="true"] img') ||
      container.querySelector(".product-page--image img") ||
      container.querySelector("img");

    if (!activeImage) return null;

    return (
      activeImage.getAttribute("data-zoom-src") ||
      activeImage.getAttribute("data-src") ||
      activeImage.getAttribute("src")
    );
  }

  function createModal() {
    let modal = document.querySelector(".custom-image-popup");

    if (modal) return modal;

    modal = document.createElement("div");
    modal.className = "custom-image-popup";
    modal.innerHTML = `
      <div class="custom-image-popup__overlay"></div>
      <button class="custom-image-popup__close" type="button" aria-label="Close">×</button>
      <div class="custom-image-popup__inner">
        <img class="custom-image-popup__img" src="" alt="">
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector(".custom-image-popup__overlay").addEventListener("click", closeModal);
    modal.querySelector(".custom-image-popup__close").addEventListener("click", closeModal);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeModal();
      }
    });

    return modal;
  }

  function openModal(imageSrc) {
    if (!imageSrc) return;

    const modal = createModal();
    const modalImage = modal.querySelector(".custom-image-popup__img");

    modalImage.src = imageSrc;

    modal.classList.add("is-active");
    document.documentElement.classList.add("custom-popup-open");
  }

  function closeModal() {
    const modal = document.querySelector(".custom-image-popup");

    if (!modal) return;

    modal.classList.remove("is-active");
    document.documentElement.classList.remove("custom-popup-open");
  }

  document.addEventListener("click", function (event) {
    const clickedImageContainer = event.target.closest(
      ".image--container, .product-page--images-container, .product-page--image"
    );

    if (!clickedImageContainer) return;

    if (
      event.target.closest("button") ||
      event.target.closest("a") ||
      event.target.closest(".product-page--thumb")
    ) {
      return;
    }

    const productImageContainer =
      clickedImageContainer.closest(".product-page--images-container") ||
      clickedImageContainer;

    const imageSrc = getImageSrc(productImageContainer);

    openModal(imageSrc);
  });

   const PRODUCT_FORM_SELECTOR =
    ".product-page--cart-form form, form.shopify-product-form[action*='/cart/add'], form[action*='/cart/add']";

  function getShopifyRoute(routeName, fallbackPath) {
    const routes = window.Shopify && Shopify.routes ? Shopify.routes : {};
    let url = routes[routeName];

    if (!url) {
      const root = routes.root || "/";
      url = root.replace(/\/$/, "") + fallbackPath;
    }

    return url.endsWith(".js") ? url : url + ".js";
  }

  function getProductForms() {
    return document.querySelectorAll(PRODUCT_FORM_SELECTOR);
  }

  function getAddButton(form) {
    return (
      form.querySelector("#add") ||
      form.querySelector('[type="submit"]') ||
      form.querySelector('[name="add"]') ||
      form.querySelector(".add")
    );
  }

  function setLoading(form, isLoading) {
    const button = getAddButton(form);

    if (!button) return;

    if (isLoading) {
      button.setAttribute("data-loading", "true");
      button.setAttribute("aria-busy", "true");
      button.setAttribute("disabled", "disabled");
    } else {
      button.setAttribute("data-loading", "false");
      button.removeAttribute("aria-busy");
      button.removeAttribute("disabled");
    }
  }

  function removeError(form) {
    form.querySelectorAll("p.error, .custom-atc-error").forEach(function (error) {
      error.remove();
    });
  }

  function showError(form, message) {
    removeError(form);

    const error = document.createElement("p");
    error.className = "error custom-atc-error";
    error.textContent = message || "Something went wrong. Please try again.";

    form.appendChild(error);
  }

  function getSealOptionContainer(input) {
    return input ? input.closest(".sls-option-container") : null;
  }

  function setSealRadioState(input, active) {
    if (!input) return;

    input.checked = active;

    const optionContainer = getSealOptionContainer(input);
    const radioWrapper = input.closest('[role="radio"]');

    if (optionContainer) {
      optionContainer.classList.toggle("sls-active", active);
    }

    if (radioWrapper) {
      radioWrapper.setAttribute("aria-checked", active ? "true" : "false");
    }
  }

  function forceSealOneTimeDefault(form) {
    if (form.dataset.sealDefaultFixed === "true") return;

    const oneTimeInput = form.querySelector(
      'input.sls-option[data-type="one_time"], input[name^="subs_type_"][value="one_time"]'
    );

    const subscriptionInput = form.querySelector(
      'input.sls-option[data-type="subscription"], input[name^="subs_type_"][value="0"]'
    );

    const sellingPlanInput = form.querySelector('[name="selling_plan"]');

    if (!oneTimeInput || !sellingPlanInput) return;

    setSealRadioState(oneTimeInput, true);
    setSealRadioState(subscriptionInput, false);

    sellingPlanInput.value = "";

    form.dataset.sealDefaultFixed = "true";
  }

  function getActiveSealPurchaseType(form) {
    const checkedInput =
      form.querySelector('input.sls-option[name^="subs_type_"]:checked') ||
      form.querySelector('input[name^="subs_type_"]:checked');

    if (checkedInput) {
      return {
        type: checkedInput.getAttribute("data-type") || checkedInput.value,
        value: checkedInput.value
      };
    }

    const activeContainer = form.querySelector(".sls-option-container.sls-active");

    if (activeContainer) {
      const activeInput = activeContainer.querySelector("input.sls-option, input[name^='subs_type_']");

      if (activeInput) {
        return {
          type: activeInput.getAttribute("data-type") || activeInput.value,
          value: activeInput.value
        };
      }
    }

    return {
      type: "one_time",
      value: "one_time"
    };
  }

  function normalizeSealSubscriptionFields(form, formData) {
    const purchaseType = getActiveSealPurchaseType(form);

    const sellingPlanInput = form.querySelector('[name="selling_plan"]');
    const intervalInput = form.querySelector('[name="subs_interval"]');

    const isSubscription =
      purchaseType.type === "subscription" ||
      purchaseType.value === "0";

    if (!isSubscription) {
      formData.delete("selling_plan");
      formData.delete("subs_interval");

      if (sellingPlanInput) {
        sellingPlanInput.value = "";
      }

      return;
    }

    const sellingPlanValue =
      (intervalInput && intervalInput.value) ||
      (sellingPlanInput && sellingPlanInput.value) ||
      "";

    if (sellingPlanValue) {
      formData.set("selling_plan", sellingPlanValue);

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanValue;
      }
    } else {
      formData.delete("selling_plan");
    }
  }

  function getCustomMaxQuantity(form, variantId) {
    const selectedVariantOption =
      form.querySelector('select[name="id"] option:checked') ||
      form.querySelector('select[name="id"] option[value="' + variantId + '"]');

    const maxFromOption = selectedVariantOption
      ? selectedVariantOption.getAttribute("data-max-cart-qty")
      : "";

    const maxFromForm = form.getAttribute("data-max-cart-qty");

    const maxQuantity = parseInt(maxFromOption || maxFromForm || "", 10);

    return isNaN(maxQuantity) ? null : maxQuantity;
  }

  async function validateCustomMaxQuantity(form, formData) {
    const variantId = String(formData.get("id") || "");
    const requestedQuantity = parseInt(formData.get("quantity") || "1", 10);

    if (!variantId || isNaN(requestedQuantity)) return;

    const maxQuantity = getCustomMaxQuantity(form, variantId);

    if (!maxQuantity) return;

    const cartResponse = await fetch(getShopifyRoute("cart", "/cart"), {
      headers: {
        Accept: "application/json"
      }
    });

    const cart = await cartResponse.json();

    const formSellingPlan = formData.get("selling_plan") || "";

    const existingQuantity = cart.items
      .filter(function (item) {
        const sameVariant = String(item.variant_id || item.id) === variantId;

        const itemSellingPlan =
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan &&
          item.selling_plan_allocation.selling_plan.id
            ? String(item.selling_plan_allocation.selling_plan.id)
            : "";

        return sameVariant && String(itemSellingPlan) === String(formSellingPlan);
      })
      .reduce(function (total, item) {
        return total + item.quantity;
      }, 0);

    const remainingQuantity = maxQuantity - existingQuantity;

    if (remainingQuantity <= 0) {
      throw new Error("The maximum quantity of this item is already in your cart.");
    }

    if (requestedQuantity > remainingQuantity) {
      throw new Error(
        "Only " + remainingQuantity + " more item(s) can be added to cart."
      );
    }
  }

  async function updateCartCount() {
    try {
      const response = await fetch(getShopifyRoute("cart", "/cart"), {
        headers: {
          Accept: "application/json"
        }
      });

      const cart = await response.json();

      document.querySelectorAll("[data-cart-count]").forEach(function (item) {
        item.setAttribute("data-cart-count", cart.item_count);
        item.textContent = cart.item_count;
      });

      const viewport = document.querySelector(".layout--viewport");

      if (viewport) {
        viewport.setAttribute("data-cart-empty", cart.item_count === 0 ? "true" : "false");
      }
    } catch (error) {
      console.log("Cart count update failed", error);
    }
  }

  function refreshAndOpenCart(button) {
    if (typeof window.trigger === "function") {
      window.trigger("theme:cart:refresh");

      setTimeout(function () {
        window.trigger("theme:cart:open", button);
      }, 250);

      return;
    }

    window.dispatchEvent(new CustomEvent("theme:cart:refresh"));

    setTimeout(function () {
      window.dispatchEvent(
        new CustomEvent("theme:cart:open", {
          detail: button
        })
      );
    }, 250);
  }

  async function addToCart(form) {
    removeError(form);
    setLoading(form, true);

    const formData = new FormData(form);
    const button = getAddButton(form);

    const variantId = formData.get("id");

    if (!variantId) {
      showError(form, "Please select a variant.");
      setLoading(form, false);
      return;
    }

    normalizeSealSubscriptionFields(form, formData);

    try {
      await validateCustomMaxQuantity(form, formData);

      const response = await fetch(getShopifyRoute("cart_add", "/cart/add"), {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json"
        }
      });

      const data = await response.json().catch(function () {
        return {};
      });

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Add to cart failed."
        );
      }

      await updateCartCount();

      refreshAndOpenCart(button);

      setLoading(form, false);
    } catch (error) {
      showError(form, error.message);
      setLoading(form, false);
    }
  }

  function initSealDefaults() {
    getProductForms().forEach(function (form) {
      forceSealOneTimeDefault(form);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSealDefaults();

    setTimeout(initSealDefaults, 500);
    setTimeout(initSealDefaults, 1500);
  });

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target.closest(PRODUCT_FORM_SELECTOR);

      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addToCart(form);
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      const button = event.target.closest("#add, button[name='add'], .add");

      if (!button) return;

      const form = button.closest(PRODUCT_FORM_SELECTOR);

      if (!form) return;

      if ((button.getAttribute("type") || "").toLowerCase() === "submit") {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      addToCart(form);
    },
    true
  );

})();